/* eslint-disable max-len */

export default {
  name: 'DistributorDetails',

  /**
   * @override
   */
  data() {
    return {
      distributor: {},
      fields: [
        {
          key: 'given_name',
          label: 'Nombre',
          class: 'data'
        },
        {
          key: `actions`,
          label: ``,
          class: 'actions'
        }
      ],
      addUser: false,
      removeUser: false,
      modalId: 'add-user-modal',
      users: [],
      selectedUsers: [],
      uuid_user_selected: null,
      onboardingLink: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      default: 'distributor'
    }
  },
  methods: {
    /**
     * Obtenemos la información relativa a las operaciones del interviniente
     */
    fetchData() {
      const cfg = {
        params: {
          $expand: 'users'
        }
      };
      if (this.limit) {
        cfg.params.$limit = this.limit;
      }
      const metodo =
        this.type === 'distributor'
          ? this.$distributorsService.getDistributorByUUId
          : this.$subdistributorsService.getSubdistributorByUUId;
      metodo(this.id, cfg).then(res => {
        this.distributor = res.data.distributor || res.data.subdistributor || {};
      });
    },
    /**
     * @override
     */
    userAdding() {
      this.addUser = true;
      setTimeout(() => {
        this.$bvModal.show(this.modalId);
      }, 1);
    },
    /**
     * @override
     */
    searchUser(str) {
      const _field = this.type === 'distributor' ? 'uuid_distributor' : 'uuid_subdistributor';
      const value = this.type === 'distributor' ? this.distributor.uuid : this.distributor.uuid_distributor;
      if (str.trim() !== '') {
        // eslint-disable-next-line prefer-const
        let filters = {};
        filters[_field] = [{ ne: `${value}` }];
        if (str && str !== '') {
          filters['given_name'] = [{ in: `%${str.trim()}%` }];
        }

        const cfg = {
          params: {
            $filter: JSON.stringify(filters)
          }
        };

        this.$usersService.getUsers('given_name asc', cfg).then(res => {
          this.users = res.data.users.map(x => {
            x.name = `${x.given_name} ${x.family_name_1} ${x.family_name_2 ? x.family_name_2 : ''}`;
            return x;
          });
        });
      }
    },
    /**
     * @override
     */
    addSelectedUsers() {
      if (!this.selectedUsers.length) {
        throw new Error('No hay usuarios seleccionados');
      }
      this.selectedUsers.forEach(async element => {
        const distributoirUUid = this.distributor._links.distributor;
        let subdistributoirUUid = this.distributor._links._self.href;
        try {
          if (this.type === 'distributor') {
            subdistributoirUUid = null;
          }
          const result = await this.$usersService.changeDistributor(
            element.uuid,
            distributoirUUid,
            subdistributoirUUid
          );
          this.closeModal();
          if (result) {
            this.$toast.success('Completado', `Usuarios añadidos a ${this.distributor.key_name}`);
          } else {
            throw new Error('No results');
          }
        } catch (error) {
          this.$toast.error('Error:', error);
        }
      });
    },
    /**
     * @override
     */
    deleteUser(user) {
      this.user_selected = user;
      this.user_selected._links = {};
      this.removeUser = true;
      setTimeout(() => {
        this.$bvModal.show(this.modalId);
      }, 1);
    },
    /**
     * @override
     */
    confirmDeleteUser() {
      if (this.type === 'distributor') {
        this.$usersService
          .changeDistributor(this.user_selected.uuid, null, null)
          .then(res => {
            this.$toast.success(res.result.http_code, res.result.info);
          })
          .catch(err => {
            this.$toast.error(err.name, err.message);
          })
          .finally(() => {
            this.closeModal();
          });
      } else {
        this.$usersService
          .changeDistributor(this.user_selected.uuid, this.distributor._links._self.href, null)
          .then(res => {
            this.$toast.success(res.result.http_code, res.result.info);
          })
          .catch(err => {
            this.$toast.error(err.name, err.message);
          })
          .finally(() => {
            this.closeModal();
          });
      }
    },
    /**
     * @override
     */
    closeModal() {
      this.selectedUsers = [];
      this.addUser = false;
      this.uuid_user_selected = null;
      this.removeUser = false;
      this.$bvModal.hide(this.modalId);
      this.fetchData();
    },
    /**
     * Copy string to clipboard
     * @param {*} str String to copy
     */
    copyStringToClipboard(str) {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style = { position: 'absolute', left: '-9999px' };
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast.success('Copiado', 'Enlace copiado en el portapapeles.');
    }
  },

  /**
   * @override
   */
  created() {
    const onboardingOrigin = process.env.VUE_APP_ONBOARDING_HOST;
    this.onboardingLink = new URL(
      `?${this.type === 'subdistributor' ? 'sd' : 'ds'}=${this.id}`,
      onboardingOrigin
    ).toString();
  },

  /**
   * @override
   */
  beforeMount() {
    this.fetchData();
  }
};
